import { BlockDefinition, BlockRegistry } from './types';

const defs = new Map<string, BlockDefinition>();

export const Registry: BlockRegistry = {
  register(def: BlockDefinition) {
    defs.set(def.type, def);
  },
  get(type: string) {
    return defs.get(type);
  },
  list() {
    return Array.from(defs.values());
  }
};

// Temporary placeholder registrations (real ones come in Phase 4)
Registry.register({
  type: 'heading',
  currentSchemaVersion: 1,
  validate: (data) => {
    const d = data as { level: 1|2|3; text: string };
    if (!d || typeof d.text !== 'string') throw new Error('heading.text required');
    if (![1,2,3].includes(d.level)) throw new Error('heading.level invalid');
    return d;
  }
});

Registry.register({
  type: 'paragraph',
  currentSchemaVersion: 1,
  validate: (data) => {
    // RichTextJSON placeholder — real validation added in Phase 4
    const d = data as { richText: any };
    if (!d) throw new Error('paragraph.richText required');
    return d;
  }
});
